<template>
  <router-link
    :to="{ name: 'Home' }"
    class="logo"
    :class="mobileMenu || $vuetify.breakpoint.smAndDown ? 'mx-auto' : ''"
  >
    <transition name="fade" mode="out-in" appear>
      <v-skeleton-loader
        v-if="companiesConfig && !companiesConfig.logo && !logoLoading"
        class="skeleton_btn"
        v-bind="attrs"
        type="button"
      ></v-skeleton-loader>
      <img v-else :src="companiesConfig.logo['svg-light']" :onload="(logoLoading = true)" />
    </transition>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'HeaderLogo',
  props: {
    mobileMenu: Boolean,
  },
  data() {
    return {
      logoLoading: false,
      attrs: {
        // class: 'mb-5',
        // boilerplate: true,
        // elevation: 3
      },
    }
  },
  computed: {
    ...mapGetters(['companiesConfig']),
  },
}
</script>
<style lang="scss" scoped>
.logo {
  display: grid;
  align-content: center;
  img {
    width: auto;
    height: 46px !important;
    max-width: 125px;
  }
}
</style>
